/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Set_NowInputs */

const en_orders_set_now = /** @type {(inputs: Orders_Set_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Now`)
};

const es_orders_set_now = /** @type {(inputs: Orders_Set_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poner ahora`)
};

/**
* | output |
* | --- |
* | "Set Now" |
*
* @param {Orders_Set_NowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_set_now = /** @type {((inputs?: Orders_Set_NowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Set_NowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_set_now(inputs)
	return es_orders_set_now(inputs)
});